(function ($) {

    $(document).ready(function () {
        if ($('.two-col-with-more-link').length > 0) {
            $(".two-col-with-more-link .link-more span").on("click", function() {
                if ($(this).hasClass("less")) {
                    $('.two-col-with-more-link .column-wrapper .col-two').removeClass('open');
                  $(".two-col-with-more-link .link-more span").removeClass("less");
                  $(this).removeClass("less");
                  $(this).text("View More");
                } else {
                    $('.two-col-with-more-link .column-wrapper .col-two').addClass('open');
                  $(this).addClass("less");
                  $(this).text("View Less");
                }
              });

            $(document).on('click', '.two-col-with-more-link .link-more', function () { 
                headerHeight = $(this).parents('.two-col-with-more-link').offset().top - $("header").outerHeight() - $(".sticky-nav").outerHeight();
                $("html, body").animate(
                    {
                        scrollTop: headerHeight,
                    },
                    600,
                    "linear"    
                );
            });
        }

    });
  
    $(window).on("load", function () {
        var height = $(".two-col-with-more-link .column-wrapper .col-two").height();
        if(height > 380) {
            $(".two-col-with-more-link .link-more").show();
            $(".two-col-with-more-link .column-wrapper .col-two").addClass("max-height");
        }
        else {
            $(".two-col-with-more-link .column-wrapper .col-two").removeClass("max-height");
          $(".two-col-with-more-link .link-more").hide();
        }
      });

})(jQuery);